import React, { useEffect, useState, useRef } from 'react';
import './printer.css';
import logo from './logo.png';
import Moment from 'moment';

class ComponentToPrintCashIns extends React.Component {

    render() {
        const data = this.props.data;
        const param = this.props.param;
        const critere = this.props.critere;
        const endAt = this.props.endAt;
        const startAt = this.props.startAt;
        const type = this.props.type;
        const devise = this.props.devise;

        function calculTotal(data) {
            let total = 0;
            data.map((d) =>  total += d.amount);
            return total
        }

        function calculTotalAllCurrency(data) {
            let totalUSD = 0;
            let totalCDF = 0;
            data.map((d) =>  {
                if (d.currency === "FC"){
                    totalCDF += d.amount;
                }else{
                    totalUSD += d.amount;
                }
            });
            return {totalUSD, totalCDF}
        }

        let counter = 1;

        return (
            <div id="invoice" className="p-4">
                <div className="invoice-header">
                    <div className="invoice-from">
                        {/*<small>Société</small>*/}
                        <address className="m-t-5 m-b-5">
                            <strong className="text-inverse">43, AV/MAISHA, Q/GOLF, C/LUBUMBASHI, LUBUMBASHI, RD CONGO</strong><br/>
                            {param && param.company_email}<br/>
                            {param && param.company_contact}<br/>
                            684/2022<br/>
                            14-A-1540 Id Nat 6-93-N71158M<br/>
                            A1202525J
                        </address>
                    </div>

                    {type === "out" && <div className="invoice-date">
                        <small>RAPPORT DE SORTIE CAISSE EN {devise}</small>
                        <div className="date text-inverse m-t-5">Date : du {Moment(startAt).format("DD/MM/YYYY")} au {Moment(endAt).format("DD/MM/YYYY")} </div>
                        <div className="invoice-detail">COMPTE : {critere}</div>
                    </div>}

                    {type === "in" && <div className="invoice-date">
                        <small>RAPPORT APROVISIONNEMENT CAISSE</small>
                        <div className="date text-inverse m-t-5">Date : du {Moment(startAt).format("DD/MM/YYYY")} au {Moment(endAt).format("DD/MM/YYYY")} </div>
                        {/*<div className="invoice-detail">Due Date: 30 Days from Invoice Date</div>*/}
                    </div>}
                </div>
                {type === "out" ?
                    <>
                        <div className="invoice-content">
                            <div className="table-responsive">
                                <table className="table table-invoice table-sm table-hover table-striped table-responsive">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Compte</th>
                                        <th>Source</th>
                                        <th>Bénéficiaire</th>
                                        <th>Motif</th>
                                        <th>Montant</th>
                                        <th>Devise</th>
                                        <th>Date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data && data.map((cash) => (
                                        <tr key={cash.id}>
                                            <td>{counter++}</td>
                                            <td><b className="text-primary">{cash.account}</b></td>
                                            <td>{cash.source}</td>
                                            <td>{cash.beneficiary}</td>
                                            <td>{cash.motif}</td>
                                            <td><b>{cash.amount}</b></td>
                                            <td>{cash.currency}</td>
                                            <td>{Moment(cash.created_at).format("DD/MM/YYYY")}</td>
                                            <td></td>
                                        </tr>

                                    ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className="invoice-price">
                                <div className="invoice-price-left">
                                    <div className="invoice-price-row">
                                        <div className="sub-price">
                                            {/*<small>SUBTOTAL</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                        <div className="sub-price">
                                            <i className="fa fa-plus text-muted"></i>
                                        </div>
                                        <div className="sub-price">
                                            {/*<small>TAX (5.4%)</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-price-right">
                                    <small className="text-white fw-bold">TOTAL : </small> <span className="f-w-600"> {data && calculTotal(data)} {devise}</span>
                                </div>
                            </div>
                        </div>
                        <div className="invoice-footer">
                            <p className="text-center m-b-5 f-w-600">
                                SIGNATURE
                            </p>
                            {/*<p className="text-center">*/}
                            {/*    <span className="m-r-10"><i className="fa fa-fw fa-lg fa-globe"></i> securecapita.com</span> <br/>*/}
                            {/*    <span className="m-r-10"><i className="fa fa-fw fa-lg fa-phone-volume"></i> Telephone:(123) 456-7890</span><br/>*/}
                            {/*    <span className="m-r-10"><i className="fa fa-fw fa-lg fa-envelope"></i> Email: billing5securecapita.com</span>*/}
                            {/*</p>*/}
                        </div>
                    </>
                    :
                    <>
                        <div className="invoice-content">
                            <div className="table-responsive">
                                <table className="table table-invoice">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Source</th>
                                        <th scope="col">Montant</th>
                                        <th scope="col">Devise</th>
                                        <th scope="col">Date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data && data.map((cash) => (
                                        <tr key={cash.id}>
                                            <td>{counter++}</td>
                                            <td>{cash.source}</td>
                                            <td><b>{cash.amount}</b></td>
                                            <td>{cash.currency}</td>
                                            <td>{Moment(cash.created_at).format("DD/MM/YYYY")}</td>
                                        </tr>
                                    ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className="invoice-price">
                                <div className="invoice-price-left">
                                    <div className="invoice-price-row">
                                        <div className="sub-price">
                                            {/*<small>SUBTOTAL</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                        <div className="sub-price">
                                            <i className="fa fa-plus text-muted"></i>
                                        </div>
                                        <div className="sub-price">
                                            {/*<small>TAX (5.4%)</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-price-right">
                                    <small>TOTAL</small>
                                    <span className="f-w-600"> {data && calculTotalAllCurrency(data).totalCDF > 0 && calculTotalAllCurrency(data).totalCDF} FC</span> <br/>
                                    <span className="f-w-600"> {data && calculTotalAllCurrency(data).totalUSD > 0  && calculTotalAllCurrency(data).totalUSD} $</span>
                                </div>
                            </div>
                        </div>
                        <div className="invoice-footer">
                            <p className="text-center m-b-5 f-w-600">
                                SIGNATURE
                            </p>
                            {/*<p className="text-center">*/}
                            {/*    <span className="m-r-10"><i className="fa fa-fw fa-lg fa-globe"></i> securecapita.com</span> <br/>*/}
                            {/*    <span className ="m-r-10"><i className="fa fa-fw fa-lg fa-phone-volume"></i> Telephone:(123) 456-7890</span><br/>*/}
                            {/*    <span className="m-r-10"><i className="fa fa-fw fa-lg fa-envelope"></i> Email: billing5securecapita.com</span>*/}
                            {/*</p>*/}
                        </div>
                    </>
                }
            </div>
        );
    }
};
export default ComponentToPrintCashIns;
